import { errorLogger } from "./error.utils";

export function getRecaptchaToken(): Promise<string> {
  const apiKey =
    window.__ENVS__.RECAPTCHAV3 || import.meta.env.VITE_RECAPTCHAV3;
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      if (apiKey) {
        window.grecaptcha
          .execute(apiKey, { action: "next" })
          .then((token: string) => resolve(token), errorLogger);
      } else {
        errorLogger("Recaptcha Error: Unable to resolve execution.");
        reject(new Error("Recaptcha Error: Unable to resolve execution."));
      }
    });
  });
}
